import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPostCompanyDebitsRequestSchema,
  TPostCompanyDebitsResponseSchema,
} from "./postCompanyDebits.schema";

export const postCompanyDebits = (axios: IAxiosInstance) => {
  return async (data: TPostCompanyDebitsRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TPostCompanyDebitsResponseSchema>
    >(`/api/company-debits`, data);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
